// extracted by mini-css-extract-plugin
export default {"root":"Space_root__8sMFB","vertical":"Space_vertical__fQSLc"};